import moment from 'moment'
import React, { useRef, useState } from 'react'
import { useQuery } from 'react-query'

import { CenteredSpinner, Col, Container } from 'react-angle-dashboard-components'
import { FormData } from '../../interfaces/eligibility'
import { SearchResults } from './SearchResults/SearchResults'
import { SearchForm } from './SearchForm/SearchForm'
import { eligibilityService } from '../../services'
import { IGetEligibilityInfoReqBody } from '../../services/eligibility'

// const emptyForm = {
//   firstName: 'angle',
//   lastName: 'silver',
//   memberId: '235244501',
//   dateOfBirth: '1965-01-23',
//   dateOfService: '' // use "2022-12-28" for inactive
// }

const emptyForm = {
  firstName: '',
  lastName: '',
  memberId: '',
  dateOfBirth: '',
  dateOfService: ''
}

const emptyCriteriaData = {
  first_name: '',
  last_name: '',
  member_id: '',
  date_of_birth: ''
}

const emptyQueryData = {
  firstName: '',
  lastName: '',
  memberId: '',
  dateOfBirth: ''
}

interface IQueryData {
  firstName: string
  lastName: string
  memberId: string
  dateOfBirth: string
  dateOfService?: string
}

export const EligibilitySearchContent = () => {
  const [queryEnabled, setQueryEnabled] = useState(false)
  const [clearDataTime, setClearDataTime] = useState('')
  const [formData, setFormData] = useState<FormData>(emptyForm)
  const [message, setMessage] = useState<string | undefined>(undefined)

  const [queryData, setQueryData] = useState<IQueryData>(emptyQueryData)

  const [criteriaData, setCriteriaData] = useState<IGetEligibilityInfoReqBody>(emptyCriteriaData)

  const queryFn = async () => {
    const body = {
      first_name: queryData.firstName,
      last_name: queryData.lastName,
      member_id: 'ANG' + queryData.memberId,
      date_of_birth: queryData.dateOfBirth,
      date_of_service: queryData.dateOfService
    }

    setCriteriaData(body)

    const res = await eligibilityService.getEligibilityInfo(body)
    return res
  }

  const { data, isLoading } = useQuery(['getEligibility', queryData], queryFn, {
    enabled: queryEnabled,
    refetchOnWindowFocus: false,
    retry: 0,
    onSuccess: (data) => {
      // clear form for HIPPA reasons (requirement is to leave form filled if error but clear if success)
      if (data) {
        // only clear if we got some data back
        setFormData(emptyForm)
      }
    },
    onSettled: () => {
      const time = moment(new Date().getTime() + 10 * 1000 * 60).format(
        'hh:mm'
      )
      setClearDataTime(time)
      // clear all data after 10 minutes
      setTimeout(() => {
        clearResults()
      }, 1000 * 60 * 10)
    }
  })

  const setNewQuery = () => {
    setQueryEnabled(true)
    setMessage("")
  }

  const clearResults = (msg?: string) => {
    setCriteriaData(emptyCriteriaData)
    setQueryEnabled(false)
    setFormData(emptyForm)
    setMessage(msg)
  }

  // set individual claim toggle on table
  const [selected, setSelected] = useState<string | null>(null)
  const toggleSelect = (id: string) =>
    setSelected((current) => (id === current ? null : id))

  const showPrintBtn = data && queryEnabled ? true : false

  const printRef = useRef(null)
  const [formatForPrint, setFormatForPrint] = useState(false)
  const onBeforePrint = () => {
    setFormatForPrint(true)
    return new Promise(function (resolve) {
      setTimeout(resolve, 10)
    })
  }

  const onAfterPrint = () => {
    setFormatForPrint(false)
  }

  return (
    <Container style={{ padding: '80px 30px' }}>
      <SearchForm
        formData={formData}
        setFormData={setFormData}
        setQueryData={setQueryData}
        setNewQuery={setNewQuery}
        showPrintBtn={showPrintBtn}
        printRef={printRef}
        onBeforePrint={onBeforePrint}
        onAfterPrint={onAfterPrint}
      />
      {isLoading && <CenteredSpinner />}
      {queryEnabled && !isLoading && (
        <SearchResults
          clearDataTime={clearDataTime}
          criteriaData={criteriaData}
          clearResults={clearResults}
          eligibilityResult={data}
          formatForPrint={formatForPrint}
          hideAccums={!!queryData.dateOfService}
          ref={printRef}
          selected={selected}
          toggleSelect={toggleSelect}
        />
      )}
      {message && (
        <Col
          className="mt-5 py-3 px-4 fs-20"
          sm={6}
          xs={12}
          style={{ background: 'rgba(35, 125, 131, 0.14)', borderRadius: 6 }}
        >
          Thank you, we'll be in touch soon!
        </Col>
      )}
    </Container>
  )
}
